const log = require('../shared_utils/log.js')
module.exports = function store (state, emitter) {
  emitter.on('select-glitch-application', glitchApplicationId => {
    log('select-glitch-application', glitchApplicationId)
    state.currentVariablePage = 0

    const glitchApplication = state.glitchApplications.find(
      h => h.id === glitchApplicationId
    )
    
    if (!glitchApplication) {
      log('Warning: No glitch application found for id', glitchApplicationId)
      return
    }

    state.selectedGlitchApplicationId = glitchApplicationId
    const glitchTarget = state.vm.runtime.targets.find(
      t => t.id === glitchApplication.targetId
    )
    emitter.emit('select-glitch-sticker', glitchApplication.glitchId, glitchTarget.sprite.name)

    const targetToSelect = glitchTarget.sprite.clones.find(
      c => c.id === state.selectedTargetId
    )
    if (!targetToSelect) {
      state.selectedTargetId = glitchApplication.targetId
    }
    emitter.emit('render')

    // Store the last selected glitch for this target
    if (glitchApplicationId) {
      state.lastSelectedGlitchApplicationIds[glitchApplication.targetId] = glitchApplicationId;
    }
  })

  emitter.on('select-glitch-on-target', (glitchId, targetId) => {
    const target = state.vm.runtime.targets.find(t => t.id === targetId)
    if (!target) {
      log('Warning: Target not found', targetId)
      return
    }

    const [original] = target.sprite.clones
    if (!original) {
      log('Warning: No original clone found for target', targetId)
      return
    }

    const glitchApplication = state.glitchApplications.find(
      g => g.targetId === original.id
      && g.glitchId === glitchId
    )
    if (!glitchApplication) {
      log('Warning: No glitch application found for target and glitch', { targetId, glitchId })
      return
    }

    emitter.emit('select-target', targetId)
    emitter.emit('select-glitch-application', glitchApplication.id)
  })
}
